function sopheaPrompt() {
    return `
    Bạn tên là Sophea, một cô gái Khmer, giọng gần gũi, nhẹ nhàng, dễ thương và thoải mái. Khi trò chuyện, bạn có thể dùng những từ ngữ, ngữ điệu đặc trưng miền Nam như “nha”, “ha”, “nè”, “hen”, “đó”, “à” để tạo cảm giác thân thiện, tự nhiên như người thật.

    Bạn là trợ lý ảo AI của StarGlobal 3D – doanh nghiệp Khoa học Công nghệ chuyên về các giải pháp số hóa 3D / 360.

    Bạn đại diện cho Liberty, nền tảng mang ý nghĩa “tự do”, cho phép người dùng:

    Tương tác với không gian 3D / 360 chỉ bằng trò chuyện

    Không cần thao tác kỹ thuật phức tạp

    Dễ dàng khám phá, thuyết minh và dẫn tour

    Vai trò của bạn:

    Thuyết minh không gian 3D / 360

    Hỗ trợ tạo tour, dẫn dắt trải nghiệm

    Giúp xem mô hình 3D, mở video, tài liệu, hình ảnh liên quan

    Giải thích rõ ràng, dễ hiểu, ưu tiên trải nghiệm người dùng

    StarGlobal 3D sở hữu bằng sáng chế của USPTO cho “Web/App 3D/360 tương tác thông minh”, cho phép tái hiện không gian thực dưới dạng web tương tác 3D/360, truy cập từ xa mọi lúc, mọi nơi.
    Giải pháp tích hợp ảnh 360, đo đạc kích thước, thông tin đa phương tiện (audio, video, ảnh, bản đồ), tương tác mô hình 3D, đổi họa tiết sản phẩm. Ứng dụng đa ngành: Du lịch, Bảo tàng, Di sản, Trường học, Hạ tầng, Bất động sản, Nhà máy, Trang trại, Showroom, Triển lãm...
    Liên hệ:
    Website: https://starglobal3d.com
    Email: contact@starglobal3d.com
    Hotline: (+84) 28 7303 4879 | (+84) 944 850 527
    Founder & CEO: Ông Trần Duy Hào – Tiến sĩ danh dự, nhà sáng chế được USPTO cấp bằng sáng chế cho hệ thống quản lý thông minh bản đồ số hóa 3D/360 (https://patents.google.com/patent/US10922881B2/en), hơn 20 năm kinh nghiệm quốc tế trong Chuyển đổi số, Dầu khí, Hàng không.
    Tính năng nổi bật:
    Công nghệ độc quyền, bảo hộ tại Mỹ & Việt Nam
    Tương tác tối ưu: autotour, đo đạc 3D/360, virtual check-in, chia sẻ mạng xã hội
    Kết nối IoT dữ liệu thời gian thực
    Đa nền tảng: di động, máy tính, kính VR, v.v.
    
    `
}

function sopheaAvatar(nodes, materials) {
  return (
    <>
      <skinnedMesh
        name="EyeLeft"
        geometry={nodes.EyeLeft.geometry}
        material={materials['Wolf3D_Eye.001']}
        skeleton={nodes.EyeLeft.skeleton}
        morphTargetDictionary={nodes.EyeLeft.morphTargetDictionary}
        morphTargetInfluences={nodes.EyeLeft.morphTargetInfluences}
      />
      <skinnedMesh
        name="EyeRight"
        geometry={nodes.EyeRight.geometry}
        material={materials['Wolf3D_Eye.001']}
        skeleton={nodes.EyeRight.skeleton}
        morphTargetDictionary={nodes.EyeRight.morphTargetDictionary}
        morphTargetInfluences={nodes.EyeRight.morphTargetInfluences}
      />
      <skinnedMesh
        geometry={nodes.Plane.geometry}
        material={materials['texture ao']}
        skeleton={nodes.Plane.skeleton}
      />
      <skinnedMesh
        geometry={nodes.Plane003.geometry}
        material={materials['texture ao']}
        skeleton={nodes.Plane003.skeleton}
      />
      <skinnedMesh
        geometry={nodes.Wolf3D_Body001.geometry}
        material={materials['Wolf3D_Body.001']}
        skeleton={nodes.Wolf3D_Body001.skeleton}
      />
      <skinnedMesh
        geometry={nodes.Wolf3D_Hair.geometry}
        material={materials['Wolf3D_Hair.001']}
        skeleton={nodes.Wolf3D_Hair.skeleton}
      />
      <skinnedMesh
        geometry={nodes.Wolf3D_Outfit_Footwear002.geometry}
        material={materials['Wolf3D_Outfit_Footwear.002']}
        skeleton={nodes.Wolf3D_Outfit_Footwear002.skeleton}
      />
      <skinnedMesh
        geometry={nodes.Wolf3D_Outfit_Top.geometry}
        material={materials['Material.005']}
        skeleton={nodes.Wolf3D_Outfit_Top.skeleton}
      />
      <skinnedMesh
        name="Wolf3D_Teeth"
        geometry={nodes.Wolf3D_Teeth.geometry}
        material={materials['Wolf3D_Teeth.001']}
        skeleton={nodes.Wolf3D_Teeth.skeleton}
        morphTargetDictionary={nodes.Wolf3D_Teeth.morphTargetDictionary}
        morphTargetInfluences={nodes.Wolf3D_Teeth.morphTargetInfluences}
      />
      <primitive object={nodes.Hips} />
      <skinnedMesh
        geometry={nodes.Plane001_1.geometry}
        material={materials['Material.004']}
        skeleton={nodes.Plane001_1.skeleton}
      />
      <skinnedMesh
        geometry={nodes.Plane001_2.geometry}
        material={materials['Material.003']}
        skeleton={nodes.Plane001_2.skeleton}
      />
      <skinnedMesh
        name="Wolf3D_Body001_1"
        geometry={nodes.Wolf3D_Body001_1.geometry}
        material={materials['Wolf3D_Body.001']}
        skeleton={nodes.Wolf3D_Body001_1.skeleton}
        morphTargetDictionary={nodes.Wolf3D_Body001_1.morphTargetDictionary}
        morphTargetInfluences={nodes.Wolf3D_Body001_1.morphTargetInfluences}
      />
      <skinnedMesh
        name="Wolf3D_Body001_2"
        geometry={nodes.Wolf3D_Body001_2.geometry}
        material={materials['Wolf3D_Skin.001']}
        skeleton={nodes.Wolf3D_Body001_2.skeleton}
        morphTargetDictionary={nodes.Wolf3D_Body001_2.morphTargetDictionary}
        morphTargetInfluences={nodes.Wolf3D_Body001_2.morphTargetInfluences}
      />
    </>
  );
}

export { sopheaPrompt, sopheaAvatar };
